// @ts-nocheck

import { DateTime } from "luxon";

// GF_CML v 1.0 March 21 2022
// GF_CML v 1.1 March 22 2022
//  Return value from gf_ncpn is now truncated.  Should be an integer returned.

/* ------------------------------------------------------------------
   Difference between two dates based on two day count conventions:
   0-actual, 1-30/360
------------------------------------------------------------------ */

function gf_datediff(newdate1, newdate2, daycount) {
  // newdate1 -    start date Date format
  // newdate2 -    end date

  let date1 = new Date(newdate1);
  let date2 = new Date(newdate2);
  let df = 0;
  let mm1 = date1.getMonth() + 1;
  let dd1 = date1.getDate();
  let yy1 = date1.getFullYear();
  let mm2 = date2.getMonth() + 1;
  let dd2 = date2.getDate();
  let yy2 = date2.getFullYear();
  let z = 0;
  let d1 = 0;
  let d2 = 0;

  switch (daycount) {
    case DIFF_ACT_ACT:
    /* actual number of days */
    case DIFF_ACT_360:
    case DIFF_ACT_365:
      df = gf_itod(mm2, dd2, yy2) - gf_itod(mm1, dd1, yy1);
      break;
    case DIFF_30_360: //* 30/360 day count basis */
      /* compute d1 */
      z = dd1 == 31 ? 30 : dd1;
      d1 = 360 * yy1 + 30 * mm1 + z;

      /* compute d2 */
      z = dd2 == 31 && (dd1 == 30 || dd1 == 31) ? 30 : z;
      z = dd2 == 31 && dd1 < 30 ? dd2 : z;
      z = dd2 < 31 ? dd2 : z;
      d2 = 360 * yy2 + 30 * mm2 + z;

      /* compute difference */
      df = d2 - d1;
      break;
    case DIFF_30_360E /* 30/360 day count basis with european adjustment */:
      dd1 = dd1 == 31 ? 30 : dd1;
      dd2 = dd2 == 31 ? 30 : dd2;
      df = (yy2 - yy1) * 360 + (mm2 - mm1) * 30 + (dd2 - dd1);
      break;

    case DIFF_30_360M:
      if (mm1 == 2) {
        if ((yy1 % 4 == 0 && yy1 % 100 != 0) || yy1 % 400 == 0) dd1 = dd1 == 29 ? 30 : dd1;
        else dd1 = dd1 == 28 ? 30 : dd1;
      }
      dd1 = dd1 == 31 ? 30 : dd1;
      dd2 = dd1 == 30 && dd2 == 31 ? 30 : dd2;
      df = (yy2 - yy1) * 360 + (mm2 - mm1) * 30 + (dd2 - dd1);
      break;
    default:
  }
  return df;
}

//---------------------------------------------
// Returns Javascript Date from Julian date
//---------------------------------------------
function gf_dtoi(jdate) {
  var yr, mo, da, mtmp;
  let newdate = new Date();
  newdate.setTime(0);

  mtmp = jdate - 1721119;
  yr = Math.trunc((4 * mtmp - 1) / 146097);
  mtmp = 4 * mtmp - 1 - 146097 * yr;
  da = Math.trunc(mtmp / 4);
  mtmp = Math.trunc((4 * da + 3) / 1461);
  da = 4 * da + 3 - 1461 * mtmp;
  da = Math.trunc((da + 4) / 4);
  mo = Math.trunc((5 * da - 3) / 153);
  da = Math.trunc(5 * da - 3 - 153 * mo);
  da = Math.trunc((da + 5) / 5);
  yr = 100 * yr + mtmp;
  if (mo < 10) mo += 3;
  else {
    mo -= 9;
    yr++;
  }

  newdate.setDate(da);
  newdate.setFullYear(yr);
  newdate.setMonth(mo - 1);
  return newdate;
}

/* ------------------------------------------------------------------
   Calculates an offset in days from a base date.
   Source: HP-12C User's Guide
   Julian Day - Starting at Jan 1, 4713 BC
------------------------------------------------------------------ */

function gf_itod(mm, dd, yy) {
  var ctmp, dtmp, mtmp, ytmp, rtmp;

  //* adjustment for February */
  if (mm > 2) {
    mtmp = mm - 3;
    ytmp = yy;
  } else {
    mtmp = mm + 9;
    ytmp = yy - 1;
  }

  /* calculate the offset in days from a base date */
  ctmp = Math.trunc(ytmp / 100);
  dtmp = ytmp - 100 * ctmp;
  rtmp = Math.trunc((146097 * ctmp) / 4) + Math.trunc(Math.trunc(1461 * dtmp) / 4) + Math.trunc((153 * mtmp + 2) / 5);
  return rtmp + dd + 1721119;
}

/* ------------------------------------------------------------------
  Return the number of days in a month.
------------------------------------------------------------------ */
function gf_dim(mm, yyyy) {
  const month_list = [0, 31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

  return ((yyyy % 4 == 0 && yyyy % 100 != 0) || yyyy % 400 == 0) && mm == 2 ? 29 : month_list[mm];
}

//---------------------------------------------
// Returns month day or full year from Julian day
// mdy = "m" or "d" or "y"
//---------------------------------------------
function gf_jul_mdy(jdate, mdy) {
  var yr, mo, da, mtmp, rtn;

  mtmp = jdate - 1721119;
  yr = Math.trunc((4 * mtmp - 1) / 146097);
  mtmp = Math.trunc(4 * mtmp - 1 - 146097 * yr);
  da = Math.trunc(mtmp / 4);
  mtmp = Math.trunc((4 * da + 3) / 1461);
  da = Math.trunc(4 * da + 3 - 1461 * mtmp);
  da = Math.trunc((da + 4) / 4);
  mo = Math.trunc((5 * da - 3) / 153);
  da = Math.trunc(5 * da - 3 - 153 * mo);
  da = Math.trunc((da + 5) / 5);
  yr = 100 * yr + mtmp;
  if (mo < 10) mo += 3;
  else {
    mo -= 9;
    yr++;
  }
  if (mdy == "m") {
    return mo;
  } else if (mdy == "d") {
    return da;
  } else {
    return yr;
  }
}

/* --------------------------------------------------------------------
   Return a CML_DATE "n" months forward using ISDA conventions.
   The same day of the month in the forward month with the
   exception that if the original date is at the end of the month,
   the forward day should also be at the end of the month.  Passing
   a negative forward month will calculate a past date.
-------------------------------------------------------------------- */
const EOM = 1;
const NEOM = 0;

function gf_fwd(jdate, delta_mm, peom) {
  var mm, dd, yy, delta_yy, dim, eom;

  mm = gf_jul_mdy(jdate, "m");
  dd = gf_jul_mdy(jdate, "d");
  yy = gf_jul_mdy(jdate, "y");
  eom = gf_dim(mm, yy) == dd ? 1 : 0; /* check if end of month */
  delta_yy = Math.trunc(delta_mm / 12); /* normalize yy and mm */
  delta_mm = delta_mm % 12;
  mm = mm + delta_mm; /* compute new month/year */
  if (mm < 1) {
    delta_yy -= 1;
    mm = 12 + mm;
  } else if (mm > 12) {
    delta_yy += 1;
    mm = mm - 12;
  }
  yy = yy + delta_yy;

  /* compute new date */
  dim = gf_dim(mm, yy); /* number of days in month/year */
  if (peom != 0) dd = dd > dim || eom == 1 ? dim : dd;
  else dd = dd > dim ? dim : dd;
  return gf_itod(mm, dd, yy);
}

/* --------------------------------------------------------------------
   Return the next normal coupon date based on three variables:
   (1) settlement date, (2) maturity date and (3) the number of months
   per period.  The strategy is to initialize the next coupon date to
   a year before the settlement date with the month and year of
   maturity.  Then the routine will go months_per_period forward until
   the date is beyond the current settlement date;  this will be
   presumed to be the next normal coupon date.
-------------------------------------------------------------------- */
const NCD = 0;
const LCD = 1;

function gf_ncd(jstl, jmty, months_per_period, calc, lcdFlag) {
  // stl and mty are Julian Date format
  // calc - 0(NCD) calc next coupon from given date, 1(LCD) calc last coupon from given date
  // lcdFlag - returns lcd if lcdFlag is true, otherwise ncd
  var i, lcd, ncd;
  var stl_mm, stl_dd, stl_yyyy, mty_mm, mty_dd, mty_yyyy, mm, dd, yyyy, mty_dim, eom;
  var bcd;

  var stl_mm = gf_jul_mdy(jstl, "m");
  var stl_dd = gf_jul_mdy(jstl, "d");
  var stl_yyyy = gf_jul_mdy(jstl, "y");
  var mty_mm = gf_jul_mdy(jmty, "m");
  var mty_dd = gf_jul_mdy(jmty, "d");
  var mty_yyyy = gf_jul_mdy(jmty, "y");

  /* initialize components for starting next coupon date */
  var mm = mty_mm;
  var dd = mty_dd;
  var yyyy = calc == NCD ? stl_yyyy - 1 : stl_yyyy + 1;

  /* check that day of month does not exceed the maximum */
  mty_dim = gf_dim(mm, yyyy);
  dd = dd > mty_dim ? mty_dim : dd;
  eom = mty_dd == gf_dim(mty_mm, mty_yyyy) ? EOM : NEOM;

  /* search for next coupon date */
  bcd = gf_itod(mm, dd, yyyy);
  if (calc == NCD) {
    ncd = bcd;
    for (i = 0; jstl >= ncd && i < 25; i++) {
      lcd = ncd;
      ncd = gf_fwd(bcd, months_per_period * i, eom);
    }
  } else {
    lcd = bcd;
    for (i = 0; jstl <= lcd && i < 25; i++) {
      ncd = lcd;
      lcd = gf_fwd(bcd, -months_per_period * i, eom);
    }
  }
  if (lcdFlag) return lcd;
  else return ncd;
}

/* --------------------------------------------------------------------
   Return the number of coupons remaining given: (1) the next coupon
   date, (2) maturity date and (3) the number of months per period.
-------------------------------------------------------------------- */
function gf_ncpn(jncd, jmty, months_per_period) {
  var ncd_mm, ncd_dd, ncd_yyyy, mty_mm, mty_dd, mty_yyyy;
  var ncpn = 0;

  /* convert next coupon date and maturity to their integer components */
  ncd_mm = gf_jul_mdy(jncd, "m");
  ncd_dd = gf_jul_mdy(jncd, "d");
  ncd_yyyy = gf_jul_mdy(jncd, "y");
  mty_mm = gf_jul_mdy(jmty, "m");
  mty_dd = gf_jul_mdy(jmty, "d");
  mty_yyyy = gf_jul_mdy(jmty, "y");

  /* calculate the number of coupons remaining */
  ncpn = (12 * mty_yyyy + mty_mm - (12 * ncd_yyyy + ncd_mm)) / months_per_period + 1;
  return Math.trunc(ncpn);
}

//---------------------------------------------
// testing a new function
// calcWhat - 0 Price
//            1 Yield
//            2 Accrued Interest
//---------------------------------------------
const CALCPRICE = 0;
const CALCYIELD = 1;
const CALCAI = 2;
const CB_ITERATIONS = 100;
const CB_TOLERANCE = 1.0e-7;

const DIFF_ACT_ACT = 0; /* actual/actual day count basis */
const DIFF_30_360 = 1; /* 30/360 day count basis */
const DIFF_30_360E = 2; /* 30/360 european day count basis */
const DIFF_ACT_360 = 3; /* actual/360 day count basis */
const DIFF_ACT_365 = 4; /* actual/365 day count basis */
const DIFF_30_360M = 5; /* 30/360 MBS convention */

// SecType
const TRSY = 0; /* treasury notes and bonds */
const AGCY = 1; /* federal agency bonds */
const MUNI = 2; /* municipal bonds */
export const CORP = 3; /* corporate bonds */
const EURO = 4; /* euro-dollar bond */
const OTHER = 5; /* other - must pass coupon frequency and day count basis */
const TRSY2 = 6; /* US treasury calculation conventions */

export function gf_price(bondTimezone: string, settle: DateTime, maturity: DateTime, cpn, yld, redem, secType) {
  // Returns price of bond given the arguments
  // settle - Settle date in javascript Date format
  // maturity - Maturity date of bond in javascript Date format
  // cpn - Coupon on bond in %
  // yld - Yield of bond in %
  // redem - Redemption price, usually 100
  // secType - Define above as const

  return gf_cb(
    // It is CRUCIAL to convert the date to given timezone.
    // We are using datetime as DATE it HAS TO BE in correct timezone
    settle
      .setZone(bondTimezone)
      .toJSDate(),
    maturity.setZone(bondTimezone).toJSDate(),
    cpn * 100,
    yld * 100,
    -1,
    redem,
    CALCPRICE,
    secType,
  );
}

export function gf_yield(bondTimezone: string, settle: DateTime, maturity: DateTime, cpn, price, redem, secType) {
  // Returns yield of bond in % given the arguments
  // settle - Settle date in javascript Date format
  // maturity - Maturity date of bond in javascript Date format
  // cpn - Coupon on bond in %
  // price - Price of bond
  // redem - Redemption price, usually 100
  // secType - Define above as const

  return (
    gf_cb(
      // It is CRUCIAL to convert the date to given timezone.
      // We are using datetime as DATE it HAS TO BE in correct timezone
      settle
        .setZone(bondTimezone)
        .toJSDate(),
      maturity.setZone(bondTimezone).toJSDate(),
      cpn * 100,
      -1,
      price,
      redem,
      CALCYIELD,
      secType,
    ) / 100
  );
}

function gf_ai(settle, maturity, cpn, price, redem, secType) {
  // Returns accured interest of bond in given the arguments
  // settle - Settle date in javascript Date format
  // maturity - Maturity date of bond in javascript Date format
  // cpn - Coupon on bond in %
  // price - Price of bond
  // redem - Redemption price, usually 100
  // secType - Define above as const

  return gf_cb(settle, maturity, cpn * 100, -1, price, redem, CALCAI, secType);
}

function gf_cb(settle, maturity, cpn, yld, price, redem, calcWhat, secType) {
  /* set variables based on the security type */
  var basis, cfreq;
  switch (secType) {
    case TRSY:
      basis = DIFF_ACT_ACT;
      cfreq = 2;
      break;
    case AGCY:
      basis = DIFF_30_360;
      cfreq = 2;
      break;
    case MUNI:
      basis = DIFF_30_360;
      cfreq = 2;
      break;
    case CORP:
      basis = DIFF_30_360;
      cfreq = 2;
      break;
    case EURO:
      basis = DIFF_30_360E;
      cfreq = 1;
      break;
    case TRSY2:
      basis = DIFF_ACT_ACT;
      cfreq = 2;
      break;
    case OTHER:
      break;
  }
  let sett = new Date(settle);
  let mat = new Date(maturity);
  let period = Math.trunc(12 / cfreq);
  let cpn_pp = cpn / cfreq;
  let cpn2_pp = cpn_pp;
  var prc, aiprc;
  let yld_pp = (0.01 * yld) / cfreq;
  let targetprc = 0;
  var tw1, fcpn_pp, tfcpn_pp, tdpdy2;
  var tinvprc, invprc, dpdy, tdpdy, dur, mdur, pv01, cyld, rinc, cinc;
  // Redemption value assumed to be 100
  let rval = 100;
  var k1, wx, twx, tnx, x, cpn2, tr, trk1, trk2;
  var xcpn, tn1, tn2, y2, ytn, kt;
  var KK, KK1, KK2, basis;
  var ncpn2, tncpn2;
  var rrate_pp;
  let rrate = yld;
  let con = 0;

  /* normalize 2nd coupon for regular bonds */
  cpn2 = cpn;

  let jstl = gf_itod(sett.getMonth() + 1, sett.getDate(), sett.getFullYear());
  let jtmty = gf_itod(mat.getMonth() + 1, mat.getDate(), mat.getFullYear());
  let ncd = gf_ncd(jstl, jtmty, period, NCD, false);
  let lcd = gf_ncd(jstl, jtmty, period, NCD, true);
  let l_n = gf_datediff(gf_dtoi(lcd), gf_dtoi(ncd), basis);
  let l_s = gf_datediff(gf_dtoi(lcd), sett, basis);
  let s_n = gf_datediff(sett, gf_dtoi(ncd), basis);
  let w = s_n / l_n;

  // calculate number of coupons remaining
  let ncpn = gf_ncpn(ncd, jtmty, period);
  ncpn2 = tncpn2 = con == 0 ? ncpn - 1.0 : gf_ncpn(ncd, con, period);
  /* assume first coupon is the same as all the other coupons */
  let tncpn = ncpn;
  fcpn_pp = tfcpn_pp = cpn_pp;
  // Calc accrued interest
  let ai = (aiprc = (cpn_pp * l_s) / l_n);
  if (calcWhat == CALCAI) return ai;

  // skipping odd first coupon logic - assuming normal coupon dates only
  let xncpn = tncpn2 - 1.0;
  let lncd = gf_ncd(jtmty, jtmty, period, LCD, true);
  let pncd = gf_ncd(jtmty, jtmty, period, LCD, false);
  // skipping odd first or last coupon
  let w2 = 1;
  let lcpn = cpn2_pp;
  if (calcWhat == CALCYIELD) {
    yld_pp = (0.01 * cpn) / cfreq;
    targetprc = price + aiprc;
  }
  let iter = 0;

  let tw2;
  let xnew;
  let xnew2;
  let conv;
  let yv32;
  do {
    iter++;
    /* if in last coupon period use simple interest */
    if (tncpn <= 1.0) {
      tw1 = 1.0 + yld_pp * w;
      if (calcWhat == CALCPRICE) tinvprc = (rval + lcpn) / tw1;
      else {
        yld_pp = (rval + lcpn - (price + ai)) / ((price + ai) * w);
        tw1 = 1.0 + yld_pp * w;
      }
      tdpdy = (-(rval + lcpn) * w) / (tw1 * tw1);
      break;
    }

    /* calculate intermediate variables for ease of computation */
    k1 = 1.0 + yld_pp;
    tn1 = Math.pow(k1, -xncpn);
    tn2 = Math.pow(k1, -(tncpn - 2.0));
    y2 = yld_pp * yld_pp;
    ytn = (yld_pp * k1) / tn1;
    ///*************************************************************** */
    if (secType == TRSY2) {
      wx = kt = w + w2;
      x = 1.0;
      if (kt > 1.0) {
        wx = kt - 1.0;
        x = 0.0;
      }
      twx = tw1 = 1.0 / (1.0 + yld_pp * wx);
      tnx = Math.pow(k1, -(tncpn - 1.0 + x));
      KK = twx * tnx;
      KK1 = -w / ((1.0 + yld_pp * w) * (1.0 + yld_pp * w));
      KK2 =
        (-wx * tnx) / ((1.0 + yld_pp * wx) * (1.0 + yld_pp * wx)) +
        (-twx * (tncpn - 1.0 + x)) / Math.pow(k1, tncpn + x);
    } else {
      tw1 = Math.pow(k1, -w);
      tw2 = Math.pow(k1, -w2);
      KK = tw1 * tn2 * tw2;
      KK1 = (-w * tw1) / k1;
      KK2 = tw2 * tn2 * (KK1 + (tw1 * (-w2 + (2.0 - tncpn))) / k1);
    }

    /* calculate price from yield and dpdy */
    if (yld_pp != 0.0) {
      xnew = cpn_pp * (1.0 - tn1) + cpn2_pp * (tn1 - tn2);
      xnew2 = xnew / yld_pp;
      tinvprc = tw1 * (tfcpn_pp + xnew2) + KK * (rval + lcpn);
      tdpdy =
        KK1 * (tfcpn_pp + xnew2) +
        tw1 *
          (-xnew / y2 +
            ((cpn_pp - cpn2_pp) * xncpn) / ytn -
            (cpn2_pp * (2.0 - tncpn)) / (yld_pp * Math.pow(k1, tncpn - 1.0))) +
        (lcpn + rval) * KK2;
    } else {
      tinvprc = xncpn * cpn_pp + tfcpn_pp + rval;
      tdpdy = 0.0000001;
    }

    /* calculate new guess for yield using Newton-Rapson method */
    if (calcWhat == CALCYIELD) yld_pp = yld_pp + (targetprc - tinvprc) / tdpdy;
  } while (!(iter >= CB_ITERATIONS || calcWhat == CALCPRICE || Math.abs(tinvprc - targetprc) < CB_TOLERANCE));

  /* exceeded number of iterations ? */
  if (iter == CB_ITERATIONS) return -1;

  /* update appropriate variables */
  if (calcWhat == CALCPRICE) prc = tinvprc - aiprc;
  else yld = 100.0 * yld_pp * cfreq;

  /* exception for corporates - if yield is equal to coupons then
       price is forced to par; also if price is par then yield
       is forced to coupon */

  if (secType == CORP && calcWhat == CALCPRICE && yld == cpn) prc = 100.0;
  else if (secType == CORP && calcWhat == CALCYIELD && prc == 100.0) yld = cpn;

  /* calculate other bond statistics */
  invprc = prc + ai;
  dpdy = (0.01 * tdpdy) / cfreq;
  dur = (-100.0 * dpdy * (1.0 + yld_pp)) / invprc;
  mdur = dur / (1.0 + yld_pp);
  yv32 = -3.125 / dpdy;
  pv01 = -0.01 * dpdy;
  cyld = (100.0 * cpn) / prc;
  cinc = fcpn_pp + cpn_pp * (ncpn2 - 1.0) + cpn2_pp * (ncpn - ncpn2 - 1.0) + lcpn;
  rrate_pp = (0.01 * rrate) / cfreq;
  if (rrate_pp == 0.0) rinc = 0.0;
  else {
    rinc = 0.0;
    tr = 1.0 + rrate_pp;
    trk1 = Math.pow(tr, tncpn - 2.0 + w2);
    trk2 = Math.pow(tr, tncpn - tncpn2 + w2 - 1.0);
    if (tncpn > 1.0)
      rinc =
        fcpn_pp * trk1 +
        (cpn_pp / rrate_pp) * (trk1 - trk2) +
        (cpn2_pp / rrate_pp) * (trk2 - Math.pow(tr, w2)) +
        lcpn -
        cinc;
  }
  /* calculate convexity - second derivative of price with respect to yield */
  yld_pp = yld_pp + 0.0000001;
  if (tncpn <= 1.0) {
    tw1 = 1.0 + yld_pp * w;
    tdpdy2 = -(rval + lcpn) * (w / (tw1 * tw1));
  } else {
    k1 = 1.0 + yld_pp;
    tn1 = Math.pow(k1, -xncpn);
    tn2 = Math.pow(k1, -(tncpn - 2.0));
    y2 = yld_pp * yld_pp;
    ytn = (yld_pp * k1) / tn1;
    if (secType == TRSY2) {
      twx = tw1 = 1.0 / (1.0 + yld_pp * wx);
      tnx = Math.pow(k1, -(tncpn - 1.0 + x));
      KK = twx * tnx;
      KK1 = -w / ((1.0 + yld_pp * w) * (1.0 + yld_pp * w));
      KK2 =
        (-wx * tnx) / ((1.0 + yld_pp * wx) * (1.0 + yld_pp * wx)) +
        (-twx * (tncpn - 1.0 + x)) / Math.pow(k1, tncpn + x);
    } else {
      tw1 = Math.pow(k1, -w);
      tw2 = Math.pow(k1, -w2);
      KK = tw1 * tn2 * tw2;
      KK1 = (-w * tw1) / k1;
      KK2 = tw2 * tn2 * (KK1 + (tw1 * (-w2 + (2.0 - tncpn))) / k1);
    }
    tdpdy2 =
      KK1 * (tfcpn_pp + (cpn_pp * (1.0 - tn1) + cpn2_pp * (tn1 - tn2)) / yld_pp) +
      tw1 *
        ((-cpn_pp * (1.0 - tn1) - cpn2_pp * (tn1 - tn2)) / y2 +
          ((cpn_pp - cpn2_pp) * xncpn) / ytn -
          (cpn2_pp * (2.0 - tncpn)) / (yld_pp * Math.pow(k1, tncpn - 1.0))) +
      (lcpn + rval) * KK2;
  }
  yld_pp = yld_pp - 0.0000001;
  conv = 100.0 * (((Math.pow(0.01 / cfreq, 2.0) / invprc) * (tdpdy2 - tdpdy)) / 0.0000001);

  if (calcWhat == CALCYIELD) return yld;
  else if (calcWhat == CALCPRICE) return prc;
  else return 0;
}
